export const DEFAULT_LANGUAGE = 'en';
export const DEFAULT_NAMESPACE = 'common';

export const LOCALES = {
  EN: 'en',
  ES: 'es',
  FR: 'fr',
  IT: 'it',
  JA: 'ja',
  KO: 'ko',
} as const;

export type LocaleType = (typeof LOCALES)[keyof typeof LOCALES];

export const HOST_LOCALE_MAPPING = {
  es: LOCALES.ES,
  fr: LOCALES.FR,
  it: LOCALES.IT,
  jp: LOCALES.JA,
  kr: LOCALES.KO,
};

export const CONTENT_LANGUAGE = {
  es: 'es',
  in: 'en-IN',
  it: 'it',
  jp: 'ja',
  kr: 'ko',
} as const;
